import { DatePipe } from "@angular/common";
import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { AbstractUserComponent } from "../abstract/user.component";
import { EntityBase } from "../../entity/EntityBase";
import { SellerContract } from "../../entity/SellerContract";
import { User } from "../../entity/User";
import { Utility } from "../../entity/Utility";
import { Pair } from "../../obj/Pair";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { KilowantContract } from "../../entity/KilowantContract";

@Component({
    selector: "app-seller-terms-view-dialog",
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: "../../../html/incs/seller-terms-view-dialog.component.html"
})
export class SellerTermsViewDialogComponent extends AbstractUserComponent {
  public contract: KilowantContract = null!;

  constructor(
      router: Router,
      route: ActivatedRoute,
      authService: AuthService,
      analyticsService: AnalyticsService,
      generalService: GeneralService,
      private datepipe: DatePipe,
      public dialogRef: MatDialogRef<any>,
      dialog: MatDialog,
    ) { super(router, route, dialog, analyticsService, generalService, authService); }

  ngOnInit(): void {

  }

  cancel(): void {
    this.dialogRef.close(null!);
  }

}
